'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _shortid = require('shortid');

var _shortid2 = _interopRequireDefault(_shortid);

require('./Field.css');

require('./Field-mobile.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckField = function (_React$Component) {
  _inherits(CheckField, _React$Component);

  function CheckField(props) {
    _classCallCheck(this, CheckField);

    var _this = _possibleConstructorReturn(this, (CheckField.__proto__ || Object.getPrototypeOf(CheckField)).call(this, props));

    _this.handleChange = function (e) {
      _this.setState({ value: e.target.checked }, function () {
        return _this.props.onChange && _this.props.onChange(_this.state.value);
      });
    };

    _this.inputId = _shortid2.default.generate();
    _this.state = {
      value: false,
      error: _this.props.error
    };
    return _this;
  }

  _createClass(CheckField, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.error !== this.props.error) {
        this.setState({ error: nextProps.error });
      }
    }
  }, {
    key: 'renderLabel',
    value: function renderLabel() {
      var _props = this.props,
          text = _props.text,
          detailed = _props.detailed,
          data = _props.data;
      var error = this.props.error;

      var detailedObj = Object.assign({}, detailed);
      if (!!data && !detailed) {
        detailedObj = data.toJS();
        detailedObj.text = text;
      }
      if (!!detailedObj) {
        return _react2.default.createElement(
          'span',
          { className: 'wsequiz_checkfield__label' },
          _react2.default.createElement(
            'label',
            { htmlFor: this.inputId },
            detailedObj.text,
            _react2.default.createElement(
              'span',
              null,
              this.props.subtext
            ),
            error ? '*' : ''
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'a',
            { href: detailedObj.url, target: '_blank' },
            detailedObj.link
          )
        );
      }
      return _react2.default.createElement(
        'label',
        { htmlFor: this.inputId },
        text,
        ' ',
        _react2.default.createElement(
          'span',
          null,
          this.props.subtext
        ),
        error ? '*' : ''
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'wsequiz_checkfield' + (this.state.value ? ' wsequiz_value' : '') + (this.state.error ? ' wsequiz_error' : '') },
        _react2.default.createElement('input', { id: this.inputId, type: 'checkbox', value: 'on', checked: this.state.value, onChange: this.handleChange }),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'svg',
                { viewBox: '0 0 24 24' },
                _react2.default.createElement('path', { d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
              ),
              _react2.default.createElement(
                'svg',
                { viewBox: '0 0 24 24' },
                _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
              )
            )
          ),
          this.renderLabel()
        )
      );
    }
  }]);

  return CheckField;
}(_react2.default.Component);

exports.default = CheckField;


//////////////////
// WEBPACK FOOTER
// ./node_modules/wse-quiz-component/lib/blocks/CheckField.js
// module id = 828
// module chunks = 0